import { useContext } from 'react';
import { Tooltip } from 'antd';
import { NavLink, useLocation } from 'react-router-dom';
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu';
import { itemDaRota, SidebarData } from "./SidebarData";
import { perfilPermitido, usePerfil } from "../../../features/auth/hooks/usePerfil";
import { SidebarContext } from '../../../providers/SidebarProvider';

function Sidebar() {
    const { isOpen, setOpen } = useContext(SidebarContext);
    const location = useLocation();
    const ativo = itemDaRota(location.pathname);
    const { perfil } = usePerfil();

    return (
        <aside className={`sidebar${isOpen ? '' : ' sidebar--recolhida'}`} aria-label="Navegação principal">
            {/*
              * O botao de recolher mora no topo, ao lado da marca. Recolhida, a barra
              * tem 80px e nao cabem os dois: fica so o botao, que e o que se procura ali.
              */}
            <div className="sidebar-marca">
                {isOpen && <>
                    <span className="sidebar-marca-simbolo" aria-hidden="true">R</span>
                    <span className="sidebar-marca-nome">Rico</span>
                </>}
                <Tooltip title={isOpen ? 'Recolher menu' : 'Expandir menu'} placement="right">
                    <button
                        type="button"
                        className="sidebar-recolher"
                        onClick={() => setOpen(!isOpen)}
                        aria-label={isOpen ? 'Recolher menu' : 'Expandir menu'}
                        aria-expanded={isOpen}
                    >
                        {isOpen ? <LuPanelLeftClose /> : <LuPanelLeftOpen />}
                    </button>
                </Tooltip>
            </div>

            <nav className="sidebar-nav">
                {SidebarData.map(secao => (
                    <div className="sidebar-secao" key={secao.titulo}>
                        {isOpen
                            ? <span className="sidebar-secao-titulo">{secao.titulo}</span>
                            : <hr className="sidebar-secao-divisor" />}
                        <ul>
                            {secao.itens.filter(item => !item.perfis || (perfil ? perfilPermitido(item.perfis, perfil) : !item.perfis.every(p => p === 'admin'))).map(item => {
                                const link = (
                                    <NavLink
                                        to={`/app/${item.link}`}
                                        className={`sidebar-item${ativo === item ? ' is-ativo' : ''}`}
                                        aria-current={ativo === item ? 'page' : undefined}
                                        aria-label={isOpen ? undefined : item.title}
                                    >
                                        <span className="sidebar-item-icone">{item.icon}</span>
                                        {isOpen && <span className="sidebar-item-texto">{item.title}</span>}
                                        {isOpen && item.emBreve && <span className="sidebar-item-etiqueta">Em breve</span>}
                                    </NavLink>
                                );

                                return (
                                    <li key={item.link}>
                                        {/* Recolhida, a barra so mostra icones: o nome vem na dica. */}
                                        {isOpen ? link : (
                                            <Tooltip title={item.emBreve ? `${item.title} (em breve)` : item.title} placement="right">
                                                {link}
                                            </Tooltip>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ))}
            </nav>
        </aside>
    )
}

export default Sidebar;
